export const saveToken = (
  accessToken: string,
  refreshToken: string,
  idToken: string
) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
  localStorage.setItem("idToken", idToken);
};

export const retrieveToken = (): string | null => {
  return localStorage.getItem("idToken");
};

export const retrieveAccessToken = (): string | null => {
  return localStorage.getItem("accessToken");
};

export const retrieveRefreshToken = (): string | null => {
  return localStorage.getItem("refreshToken");
};

export const clearTokens = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("idToken");
};

export const clearAllStorage = () => {
  localStorage.clear();
};

// Per-user preferred layout flag — persists across logout/login
export const getHasPreferredLayout = (userId: string): boolean => {
  return localStorage.getItem(`hasPreferredLayout_${userId}`) === "true";
};

export const setHasPreferredLayout = (userId: string, value: boolean): void => {
  if (value) {
    localStorage.setItem(`hasPreferredLayout_${userId}`, "true");
  } else {
    localStorage.removeItem(`hasPreferredLayout_${userId}`);
  }
};

